import "../styles/browser.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { languages, useLanguage } from "./Langs";
import Navbar from "./Navbar";
import GetLogo from "./GetLogo";
import axios from "axios";
import { getUrl, getApiUrl } from "./urlHook";
const apiUrl = getApiUrl();
const pageUrl = getUrl();

// gets back the scroll bar if you enter the page from the browse
// because that page disables the scrollbar
// it seems to "infect" the esign page
document.documentElement.style.overflow = "scroll";

// just table to show states to the user that are not confusing
const contract_states = {
  signature: "Needs review",
  complete: "Completed",
  declined: "Decliend",
  voided: "Voided",
  created: "New",
};

const MakeDocument = (props) => {
  const subject = props.subject || "";
  const eid = props.eid || "";
  const sid = props.sid || "";
  const status =
    props.status !== undefined ? contract_states[`${props.status}`] : "";
  const template = props.template || "";
  const code = props.code || "";
  const date = props.date || "";
  const key = props.key;

  let url = "";

  if (props.status.toLowerCase() === "complete") {
    url = `${pageUrl}/viewer/${eid}`;
  } else if (props.status.toLowerCase() === "declined") {
    url = `${pageUrl}/declined`;
  } else if (props.status.toLowerCase() === "signature") {
    url = `${pageUrl}/document/${sid}`;
  }

  return (
    <div className="selectDocument" key={key}>
      <a href={url} target="_blank" className="noDecoration">
        <div className="fullWidth">
          <div className="col20 ib centerText">
            <img
              src="../safesign82.png"
              alt="shs"
              className="imgCircle centerVert imgLogo"
            ></img>
          </div>
          <div className="col80 leftAlign ib centerVert noMargin">
            <div>
              <p className="ib noMargin bold">{`Subject: `}</p>
              <p className="inline noMargin">{` ${subject}`}</p>
            </div>
            {/* <div className="block noMargin">
              <p className="ib noMargin bold">{`Signer Id: `}</p>
              <p className="inline noMargin">{` ${sid}`}</p>
            </div> */}
            <div>
              <p className="ib noMargin bold">{`Status: `}</p>
              <p className="inline noMargin ">{` ${status}`}</p>
            </div>
            {/* <div>
              <p className="ib noMargin bold">{`Template: `}</p>
              <p className="inline noMargin">{` ${template}`}</p>
            </div> */}
            <div className="block noMargin">
              <p className="ib noMargin bold">{`Code: `}</p>
              <p className="inline noMargin">{` ${code}`}</p>
            </div>
            <div>
              <p className="ib noMargin bold">{`Date: `}</p>
              {/* https://www.freecodecamp.org/news/how-to-format-dates-in-javascript/ */}
              <p className="inline noMargin">{` ${new Date(
                date
              ).toLocaleDateString("en-us", {
                weekday: "long",
                year: "numeric",
                month: "short",
                day: "numeric",
              })}`}</p>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

const Browse = (props) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [openHelp, setOpenHelp] = useState(false);
  const [email, setEmail] = useState("");
  const logo = GetLogo();

  const [lang, setLang] = useLanguage();
  const [documentsIp, setDocumentsIp] = useState(null);
  const [documentsCompleted, setDocumentsCompleted] = useState(null);

  useEffect(() => {
    try {
      const s = state.session;
    } catch (ex) {
      navigate("/login");
      return;
    }
    const sessionId = state.session;
    // gets back the scroll bar if you enter the page from the browse
    // because that page disables the scrollbar
    // it seems to "infect" the esign page
    document.documentElement.style.overflow = "scroll";
    (async () => {
      const response = await axios.post(`${apiUrl}/browse`, {
        sessionId: sessionId,
      });

      if (!response) {
        setDocumentsIp("");
        setDocumentsCompleted("");
        navigate("/login", { error: true });
        return;
      }

      // document status
      let documents_ip = []; // in progress
      let documents_com = []; //complete
      const email = response.data.email;

      if (response) {
        setEmail(email);
        for (const datum of response.data.documents) {
          const signers = datum.signers.filter((f) => {
            return f.email.toLowerCase() === email.toLowerCase();
          });
          for (const s of signers) {
            const d = {
              subject: datum.emailSubject,
              key: s._id, //react js makes us use a unique key for arrays that contain reactjs elements
              eid: datum._id,
              sid: s._id,
              template: datum.pdfTemplate,
              status: datum.status,
              code: s.code || "N/A",
              date: datum.createDate,
            };
            if (datum.status === "complete") {
              if (!documents_com.find((f) => f.eid === datum._id)) {
                documents_com.push(d);
              }
            } else if (
              s.state.toUpperCase() !== "DONE" &&
              datum.status === "signature"
            ) {
              documents_ip.push(d);
            }
          }
        }
      }

      const sortDate = (a, b) => new Date(b.date) - new Date(a.date);

      documents_com = documents_com.sort(sortDate);
      documents_ip = documents_ip.sort(sortDate);

      setDocumentsIp(documents_ip.map((d) => MakeDocument(d)));
      setDocumentsCompleted(documents_com.map((d) => MakeDocument(d)));
    })();
  }, []);

  if (documentsIp === null || documentsCompleted === null) {
    // show spinny gif while loading
    return (
      <div>
        <img
          src="../Spinner-0.7s-200px (1).svg"
          alt="loading please wait."
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            maxWidth: "500px",
            width: "500px",
            transform: "translate(-50%, -50%)",
          }}
        ></img>
      </div>
    );
  }

  // the actual page
  return (
    <div id="browser">
      <Navbar
        id="navbar"
        lang={[lang, setLang]}
        disableToolBar
        setOpenHelp={setOpenHelp}
        openHelp={openHelp}
        color={logo.color}
        banner={logo.banner}
        helpColor={logo.helpColor}
      ></Navbar>

      <div className="centerText fullWidth documentHeader">
        <h1 className="smallPadding">
          {lang.DocumentsFor} <u>{email}</u>
        </h1>
      </div>

      <div id="documentBody">
        <div className="documentBrowser">
          <div className="centerHeader" id="contractsHeader">
            <h1>{lang.InProgress}</h1>
            <div>
              {lang.Documents}: {documentsIp.length}
            </div>
            <div> {lang.ReviewAndSign} </div>
          </div>
          <div className="contractsBody scrollBar" id="contracts">
            {documentsIp.length > 0 ? (
              documentsIp
            ) : (
              <div
                style={{
                  color: "red",
                  textAlign: "center",
                }}
              >
                <h3>There are no documents in progress for this email</h3>
              </div>
            )}
          </div>
        </div>

        <div className="documentBrowser">
          <div className="centerHeader" id="contractsHeader">
            <h1>{lang.Completed}</h1>
            <div>
              {lang.Documents}: {documentsCompleted.length}
            </div>
            <div> {lang.FinishedDocuments} </div>
          </div>
          <div className="contractsBody scrollBar" id="contracts">
            {documentsCompleted.length > 0 ? (
              documentsCompleted
            ) : (
              <div
                style={{
                  color: "red",
                  textAlign: "center",
                }}
              >
                <h3>There are no completed documents for this email</h3>
              </div>
            )}
          </div>
        </div>
      </div>

      <p
        style={{
          textAlign: "center",
          margin: "40px",
          marginTop: "0px",
          paddingTop: "10px",
        }}
      >
        <strong>
          Documents that need reviewing will expire after 15 days.
        </strong>
        <br></br>
        {lang.Experience}: <br></br>
        <a href="mailto:info@myshs.com">info@myshs.com</a>
      </p>
    </div>
  );
};

export default Browse;
